import { MediaType } from './ImagePicker.types';

export const ImageFileTypes: string[] = ['image/png', 'image/jpg', 'image/jpeg', 'image/heic', 'image/heif'];
export const ImageURITypes: string[] = [];
export const ImageTypes: string[] = [...ImageFileTypes, ...ImageURITypes];

export const MediaTypeInput = {
  images: 'image/*',
  videos: 'video/mp4,video/quicktime,video/x-m4v,video/*',
  livePhotos: '',
  ...ImageTypes.reduce((acc, type) => ({ ...acc, [type as MediaType]: type }), {}),
} as Record<MediaType, string>;
